import { JoiTranslatesScheme } from "./DtoTranslateScheme";
import Joi from "joi";

export const JoiOrderTechnicalEntityScheme = Joi.object({
  core_id: Joi.number().integer().required(),
  created_at: Joi.string().required(),
  id: Joi.number().integer().required(),
  key: Joi.string().allow("").required(),
  restaurant: {
    domain: Joi.string().required(),
    id: Joi.number().integer().required(),
    name: JoiTranslatesScheme,
  },
  status: Joi.number().integer().required(),
  updated_at: Joi.string().required(),
});
